import { Injectable } from '@angular/core';
import { BaseService, Pagination } from '../core';
import { NoticeBoard, NoticeBoardListDto } from '../dto';

@Injectable({
  providedIn: 'root',
})
export class NoticeBoardService extends BaseService {
  getNoticeLists(noticeBoardListDto: NoticeBoardListDto, pagination: Pagination) {
    return super.paginate<NoticeBoard>('/notice-board', noticeBoardListDto, pagination);
  }

  getPromotionNoticeList(noticeBoardListDto: NoticeBoardListDto, pagination: Pagination) {
    return super.paginate<NoticeBoard>('/promotion-notice', noticeBoardListDto, pagination);
  }

  getDetailLists(id: number) {
    return super.get<NoticeBoard>(`/notice-board/${id}`);
  }
}
